 
import React, { useCallback } from 'react';

import * as Analytics from '../../analytics';

interface Props {
  taggingLabel?: string;
  onClick?: any;
  [key: string]: any;
}

const withTaggingButtonClickHandler = (WrappedComponent: any) =>
  function TaggingButtonClick({ taggingLabel, onClick, ...rest }: Props) {
    const handleOnClick = useCallback(
      (...args) => {
        if (onClick) {
          onClick(...args);
        }
        if (taggingLabel) {
          Analytics.sendButtonEvent({
            JourneyEvent: 'Button Click',
            LinkValue: `button/${taggingLabel
              ?.replace(/\s/g, '')
              .toLowerCase()}`,
          });
        }
      },
      [onClick, taggingLabel],
    );
    return <WrappedComponent {...rest} onClick={handleOnClick} />;
  };

export default withTaggingButtonClickHandler;
